import { render } from "./InvoiceCustomerContacts.vue?vue&type=template&id=30d0f6dc&ts=true"
import script from "./InvoiceCustomerContacts.vue?vue&type=script&lang=ts"
export * from "./InvoiceCustomerContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__